
let address = "https://itdj2369lgsc.com/api/v2" // ITD Production Server
// let address = "http://192.168.68.119:3000/api/v2" // ATS Server
export let filePath = address.replace("api/v2", "api/v2"); 

export default address